import { defineMessages } from "react-intl";

const messages = defineMessages({
  language: {
    id: "userPreference.language",
    description: "Label for the user's selected language",
    defaultMessage: "Language",
  },
  currency: {
    id: "userPreference.currency",
    description: "Label for the user's selected currency",
    defaultMessage: "Currency",
  },
  distance: {
    id: "userPreference.distance",
    description: "Label for the user's selected distance unit",
    defaultMessage: "Distance",
  },
  timeFormat: {
    id: "userPreference.timeFormat",
    description: "Label for the user's selected time format",
    defaultMessage: "Time Format",
  },
  change: {
    id: "userPreference.change",
    description:
      "Label for screenreaders to indicate that the button lets users change their preference",
    defaultMessage: "Change preference",
  },
  debugTitle: {
    id: "userPreference.debug.title",
    description: "Label for debug button",
    defaultMessage: "Debug",
  },
  debugDescription: {
    id: "userPreference.debug.description",
    description: "Description for debug button",
    defaultMessage: "Change enabled features to test",
  },
  consent: {
    id: "userPreference.consent",
    description:
      "A button that allows users to change their GDPR consent preferences",
    defaultMessage: "Privacy Settings",
  },
  doNotShare: {
    id: "userPreference.doNotShare",
    description:
      "A button that allows users to change their US privacy consent preferences.",
    defaultMessage: "Do Not Share or Sell My Personal Information",
  },
  contact: {
    id: "extraInfo.contact",
    description: "Label for link to the contact/feedback page",
    defaultMessage: "Contact / Feedback",
  },
  about: {
    id: "extraInfo.about",
    description: "Label for link to the R2r about page",
    defaultMessage: "About Rome2Rio",
  },
  faq: {
    id: "extraInfo.faq",
    description: "Label for faq page",
    defaultMessage: "Frequently Asked Questions",
  },
  travelGuides: {
    id: "extraInfo.travelGuides",
    description: "Label for link to the travel guide page",
    defaultMessage: "Travel Guides",
  },
  blog: {
    id: "extraInfo.blog",
    description: "Label for link to the R2r blog",
    defaultMessage: "Rome2Rio Blog",
  },
  press: {
    id: "extraInfo.press",
    description: "Label for link to the press page",
    defaultMessage: "Press",
  },
  careers: {
    id: "extraInfo.careers",
    description: "Label for link to the careers page",
    defaultMessage: "Careers",
  },
  facebook: {
    id: "extraInfo.facebook",
    description: "Label for link to the Facebook page",
    defaultMessage: "Facebook",
  },
  twitter: {
    id: "extraInfo.twitter",
    description: "Label for link to the Twitter page",
    defaultMessage: "Follow @rome2rio on Twitter",
  },
  manageCookies: {
    id: "extraInfo.manageCookies",
    defaultMessage: "Manage cookies",
    description:
      'Label on link to the Rome2Rio "Manage cookies" modal or banner',
  },
});

export default messages;
